import React from 'react';
import { connect } from 'react-redux';

import { validateAuth } from '../../actions/authActions';


export class RedirectPage extends React.Component {

  componentDidMount() {
    const query = this.props.location.search;
    const params = new URLSearchParams(query);
    const token = params.get('t');
    if (token) {
      this.props.validateAuth(token);
    }
    this.props.history.push('/');
  }

  render() {
    return null;
  }
}

const mapDispatchToProps = dispatch => ({
  validateAuth: token => dispatch(validateAuth(token))
});

export default connect(undefined, mapDispatchToProps)(RedirectPage);



// WEBPACK FOOTER //
// ./src/components/pages/RedirectPage.jsx